let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g38XK")).then(() => parcelRequire('fnE71'));